import React, { Component } from "react";
import { PlayerComponent } from "../components";

class Player extends Component {
   constructor(props) {
      super(props);

      this.state = {
         loading: true,
      };
   }

   componentDidUpdate = (prevProps) => {
      const { url } = this.props
      if(prevProps.url !== url) {
         this.setState({
            loading: true
         })
      }
   }

   handleChange = (key, value) => {
      this.setState({
         [key]: value,
      });
   };

   render() {
      const { url, classname } = this.props;
      const { loading } = this.state;
      return <PlayerComponent url={url} classname={classname} loading={loading} handleChange={this.handleChange} />;
   }
}
export default Player;
